import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { Checkbox } from "primereact/checkbox";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import React from "react";

import { FormSectionElements, FormSections, LOVValues, RedirectSection } from "../../entities/formTemplateDataType";
import { inputElements } from "../../entities/Constants";
import { getOtherFieldOptions } from "../../utilities/ElementUtils";
import { DialogBase } from "./DialogBase";

interface Props {
//    programContainer: ProgramContainer
	ele: FormSectionElements;
    isEng: boolean;
    dialogVisible: boolean;
    callback;
}

interface State {
	pickedFieldOptions;
}

export class DialogForOrderBreakdownComponent extends DialogBase<Props, State> {
	constructor(props: Props) {
		super(props);

		this.state = {
			pickedFieldOptions: [],
		};
	}

	onChangeHandler = (newValue) => {
		this.props.ele.FilterField = newValue;
		let totalOption = [];
		let eleListPrior = [];
		if (this.props.ele.parent.parent.Datatype === 'Row') {
			let currentSection = this.props.ele.parent.parent.parent.parent as FormSections;
			let currentSubSeq = this.props.ele.parent.parent.parent.Sequence;
			currentSection.ListOfFormSubSections.filter(sub => sub.Sequence<=currentSubSeq).forEach((sub) => {
				sub.ListOfFormSectionElements.forEach(ele => {
					if (ele.Datatype==='Row' && ele.subSectionList) {
						ele.subSectionList[0].ListOfFormSectionElements.forEach(el => {
							if (sub.Sequence<this.props.ele.parent.parent.parent.Sequence || ele.Sequence==this.props.ele.parent.parent.Sequence && el.Sequence<this.props.ele.Sequence || ele.Sequence<this.props.ele.parent.parent.Sequence) {
								eleListPrior.push(el)
							}
						})
					} else {
						if (sub.Sequence<this.props.ele.parent.parent.parent.Sequence || ele.Sequence<this.props.ele.parent.parent.Sequence) {
							eleListPrior.push(ele)
						}
					}
				})
			})
		} else {
			let currentSection = this.props.ele.parent.parent as FormSections;
			let currentSubSeq = this.props.ele.parent.Sequence;
			currentSection.ListOfFormSubSections.filter(sub => sub.Sequence<=currentSubSeq).forEach((sub) => {
				sub.ListOfFormSectionElements.forEach(ele => {
					if (ele.Datatype === 'Row' && ele.subSectionList) {
						ele.subSectionList[0].ListOfFormSectionElements.forEach(el => {
							if (sub.Sequence<this.props.ele.parent.Sequence || ele.Sequence<this.props.ele.Sequence) {
								eleListPrior.push(el)
							}
						})
					} else {
						if (sub.Sequence<this.props.ele.parent.Sequence || ele.Sequence<this.props.ele.Sequence) {
							eleListPrior.push(ele)
						}
					}
				})
			})
		}

		let pickedFieldOptions = eleListPrior.filter(ele => ele.LoadBindName?.replace(/\s/g, "") == newValue)
			.map(q => {
				const container = {};
				if (q.Datatype === "Checkbox") {
					const yLOVValue = new LOVValues();
					yLOVValue.code = "Y";
					yLOVValue.description = "Y";
					const nLOVValue = new LOVValues();
					nLOVValue.code = "N";
					nLOVValue.description = "N";
					container[q.LoadBindName] = [yLOVValue, nLOVValue];
				} else {
					container[q.LoadBindName] = q.ListOfLOVValues;
				}
				return container;
			});
		totalOption.push(...pickedFieldOptions);
		
		this.setState({ pickedFieldOptions: totalOption });
		this.props.callback();
	}

	filteringHtml = () => {
		return (<>
			<div style={{ display:  "flex",  marginTop: '10px' }}>
				<div style={{ width: '25%' }}>Filtering Field</div>
				<div style={{ width: '60%' }}>
					<Dropdown options={getOtherFieldOptions(this.props.ele)} style={{width:'100%'}}
						className="ontario-dropdown-small"
						optionLabel="description"
						optionValue="code"
						value={this.props.ele.FilterField}
						onChange={(e) => {
							this.onChangeHandler(e.value);}
						}
					/>
				</div>
			</div>
			<div style={{ display:  "flex" , marginTop: '10px' }}>
				<div style={{ width: '25%' }}>Filtering Value</div>
				<div style={{ width: '60%', marginTop: '5px' }}>
					<div>
						<Dropdown style={{width:'100%'}}
							className="ontario-dropdown-small"
							options={this.state.pickedFieldOptions[0] ? this.state.pickedFieldOptions[0][this.props.ele.FilterField] : null}
							value={this.props.ele.FilterValue}
							optionLabel="description"
							optionValue="code"
							placeholder="Filtering value"
							onChange={(e) => {
								this.props.ele.FilterValue = e.value;
								this.props.callback();
							}}
						/>
					</div>
				</div>
			</div>
		</>);
	}

	isInputElement = (element: FormSectionElements) => {
		return inputElements.includes(element.Datatype);
	}

	optionalRequiredLabelHtml = () => {
		return (<>
			<div style={{ display: "flex", marginTop: '10px' }}>
				<div style={{ width: '25%' }}>
					<label htmlFor={"show_optional_label_" + this.props.ele.Sequence}>Show Optional/Required Label:</label>
				</div>
				<div style={{ width: '60%' }}>
					<Checkbox value={this.props.ele.showOptionalLabel ?? true} 
						id={"show_optional_label_" + this.props.ele.Sequence}
						onChange={(e) => { 
							this.props.ele.showOptionalLabel = e.checked; 
							this.props.callback() 
						}} 
						checked={this.props.ele.showOptionalLabel ?? true}
					/>
				</div>
			</div>

			<div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
				<div style={{ width: '25%' }}>Length in Pixel:</div>
				<div style={{ width: '60%' }}>
				<InputText className='ontario-input' disabled={this.props.isEng == false} placeholder='Length in px' title="style width in pixel for the Number field" 
					value={this.props.ele.LengthInPixel}
					onChange={(e) => {
						this.props.ele.LengthInPixel = e.target.value;
						this.props.callback();
					}} />
				</div>
			</div>
			{this.isInputElement(this.props.ele) && (
				<div style={{ display: "flex", marginTop: '10px' }}>
					<div style={{ width: '25%' }}>
						<label htmlFor={"collect_submit" + this.props.ele.Sequence}>Collect for submit:</label>
					</div>
					<div style={{ width: '60%' }}>
						<Checkbox value={this.props.ele.input?.submitCollect} 
							id={"collect_submit" + this.props.ele.Sequence}
							onChange={(e) => { 
								this.props.ele.input = {...this.props.ele.input ?? {}, submitCollect: e.checked}; 
								this.props.callback() 
							}} 
							checked={this.props.ele.input?.submitCollect}
						/>
					</div>
				</div>
			)}
		</>);
	}

	orderBreakdownConfigsHtml = () => {
		return (<>
			<div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
				<div style={{ width: '25%' }}>Product section title:</div>
				<div style={{ width: '60%' }}>
					<InputText className='ontario-input' disabled={this.props.isEng == false} placeholder='Products to check out' title="Title for the Product section" 
						value={this.props.isEng ? this.props.ele.OrderBreakdownConfig?.productSectionTitle: this.props.ele.OrderBreakdownConfig?.productSectionTitleFRA}
						onChange={(e) => {
							if (this.props.ele.OrderBreakdownConfig) {
								if (this.props.isEng) {
									this.props.ele.OrderBreakdownConfig = {...this.props.ele.OrderBreakdownConfig, productSectionTitle: e.target.value};
								} else {
									this.props.ele.OrderBreakdownConfig = {...this.props.ele.OrderBreakdownConfig, productSectionTitleFRA: e.target.value};
								}
							} else {
								if (this.props.isEng) {
									this.props.ele.OrderBreakdownConfig = {productSectionTitle: e.target.value};
								} else {
									this.props.ele.OrderBreakdownConfig = {productSectionTitleFRA: e.target.value};
								}
							}
							this.props.callback();
						}} 
					/>
				</div>
			</div>
			<div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
				<div style={{ width: '25%' }}>Payment section title:</div>
				<div style={{ width: '60%' }}>
					<InputText className='ontario-input' disabled={this.props.isEng == false} placeholder='Payment summary' title="Title for the Payment section" 
						value={this.props.isEng ? this.props.ele.OrderBreakdownConfig?.paymentSectionTitle: this.props.ele.OrderBreakdownConfig?.paymentSectionTitleFRA}
						onChange={(e) => {
							if (this.props.ele.OrderBreakdownConfig) {
								if (this.props.isEng) {
									this.props.ele.OrderBreakdownConfig = {...this.props.ele.OrderBreakdownConfig, paymentSectionTitle: e.target.value};
								} else {
									this.props.ele.OrderBreakdownConfig = {...this.props.ele.OrderBreakdownConfig, paymentSectionTitleFRA: e.target.value};
								}
							} else {
								if (this.props.isEng) {
									this.props.ele.OrderBreakdownConfig = {paymentSectionTitle: e.target.value};
								} else {
									this.props.ele.OrderBreakdownConfig = {paymentSectionTitleFRA: e.target.value};
								}
							}
							this.props.callback();
						}} 
					/>
				</div>
			</div>
			<div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
				<div style={{ width: '25%' }}>Payment column1 header:</div>
				<div style={{ width: '60%' }}>
					<InputText className='ontario-input' disabled={this.props.isEng == false} placeholder='Products' title="Header for the Payment column1" 
						value={this.props.isEng ? this.props.ele.OrderBreakdownConfig?.paymentColumn1Header: this.props.ele.OrderBreakdownConfig?.paymentColumn1HeaderFRA}
						onChange={(e) => {
							if (this.props.ele.OrderBreakdownConfig) {
								if (this.props.isEng) {
									this.props.ele.OrderBreakdownConfig = {...this.props.ele.OrderBreakdownConfig, paymentColumn1Header: e.target.value};
								} else {
									this.props.ele.OrderBreakdownConfig = {...this.props.ele.OrderBreakdownConfig, paymentColumn1HeaderFRA: e.target.value};
								}
							} else {
								if (this.props.isEng) {
									this.props.ele.OrderBreakdownConfig = {paymentColumn1Header: e.target.value};
								} else {
									this.props.ele.OrderBreakdownConfig = {paymentColumn1HeaderFRA: e.target.value};
								}
							}
							this.props.callback();
						}} 
					/>
				</div>
			</div>
			<div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
				<div style={{ width: '25%' }}>Payment column2 header:</div>
				<div style={{ width: '60%' }}>
					<InputText className='ontario-input' disabled={this.props.isEng == false} placeholder='Amount' title="Header for the Payment column2" 
						value={this.props.isEng ? this.props.ele.OrderBreakdownConfig?.paymentColumn2Header: this.props.ele.OrderBreakdownConfig?.paymentColumn2HeaderFRA}
						onChange={(e) => {
							if (this.props.ele.OrderBreakdownConfig) {
								if (this.props.isEng) {
									this.props.ele.OrderBreakdownConfig = {...this.props.ele.OrderBreakdownConfig, paymentColumn2Header: e.target.value};
								} else {
									this.props.ele.OrderBreakdownConfig = {...this.props.ele.OrderBreakdownConfig, paymentColumn2HeaderFRA: e.target.value};
								}
							} else {
								if (this.props.isEng) {
									this.props.ele.OrderBreakdownConfig = {paymentColumn2Header: e.target.value};
								} else {
									this.props.ele.OrderBreakdownConfig = {paymentColumn2Header: e.target.value};
								}
							}
							this.props.callback();
						}} 
					/>
				</div>
			</div>
			<div style={{ display: "flex", marginTop: '10px' }}>
				<div style={{ width: '25%' }}>
					<label htmlFor={"show_plate_image" + this.props.ele.Sequence}>Show plate image:</label>
				</div>
				<div style={{ width: '60%' }}>
					<Checkbox value={this.props.ele.OrderBreakdownConfig?.showPlateImage} 
						id={"show_plate_image" + this.props.ele.Sequence}
						onChange={(e) => { 
							if (this.props.ele.OrderBreakdownConfig) {
								this.props.ele.OrderBreakdownConfig = {...this.props.ele.OrderBreakdownConfig, showPlateImage: e.checked};
							} else {
								this.props.ele.OrderBreakdownConfig = {showPlateImage: e.checked};
							}
							this.props.callback();
						}} 
						checked={this.props.ele.OrderBreakdownConfig?.showPlateImage}
					/>
				</div>
			</div>
		</>);
	}

	generateContentString = () => {
		let htmlString = [];
		htmlString.push(
			<>
	            {this.scriptHtml()}
	            {this.updateBindingFieldHtml()}
	            {this.questionHintHtml()}
	            {this.emptyErrorMessageHtml()}
	            {this.errorMessageHtml()}
	            {this.richTextErrorMessageHtml()}
	            {this.tooTipHtml()}
	            {this.hintExpansionTitleHtml()}
	            {this.calloutBoxHtml()}
	            {this.filteringHtml()}
	            {this.indentHtml()}
	            {this.maskSummaryHtml()}
	            {this.fieldOnTopHtml()}
	            {this.optionalRequiredLabelHtml()}
				{this.excludeFromPayload()}
				{this.InitialVisibility()}
				{this.orderBreakdownConfigsHtml()}
			</>
		);

		return htmlString;
	};

	renderFooter = () => {
		return (
			<div>
				<Button label="OK" icon="pi pi-check" onClick={() => {
						this.props.callback(false);
				}} />
				<Button label="Cancel" onClick={() => { this.props.callback(false) }} />
			</div>
		);
	}

	generateHtmlString = () => {
		let html = [];
		html.push(
			<>
				<Dialog header={this.props.isEng ? "Order-breakdown properties for " + this.props.ele.ENUTitle : "Order-breakdown properties for" + this.props.ele.FRATitle} 
					footer={this.renderFooter()}
					visible={this.props.dialogVisible} style={{ width: '50vw' }} onHide={() => this.props.callback(false)}>
					{this.generateContentString()}
				</Dialog>
			</>
		);
		return html;
	}

	render() {
		return (
			<>
				{this.generateHtmlString()}
			</>
		);
	}
}